import { useState } from "react";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";
import useFeatureFlag, { CLAIM_BUSINESS } from "@/hooks/use-feature-flag";
import { useIsBreakPoint } from "@/hooks/use-is-break-point";
import { cn } from "@/lib/utils";

interface StatusWrapperProps {
  children: React.ReactNode;
  content: React.ReactNode;
  popoverProps?: React.ComponentProps<typeof HoverCardContent>;
  title: React.ReactNode;
}

export default function StatusWrapper({
  children,
  content,
  popoverProps = {},
  title,
}: StatusWrapperProps) {
  const [isOpen, setIsOpen] = useState(false);
  const isClaimBusinessEnabled = useFeatureFlag(CLAIM_BUSINESS);
  const isDesktop = useIsBreakPoint("md");

  if (!isClaimBusinessEnabled) {
    return null;
  }

  const { className, ...contentProps } = popoverProps;

  return (
    <>
      <HoverCard onOpenChange={setIsOpen} open={isOpen}>
        <HoverCardTrigger
          asChild
          className="items-center"
          onClick={() => setIsOpen(true)}
        >
          {children}
        </HoverCardTrigger>
        {isDesktop && (
          <HoverCardContent
            className={cn(
              "w-89 rounded-[15px] bg-deep-sea px-5 py-0 shadow-none",
              className
            )}
            {...contentProps}
          >
            <h5 className="border-white/10 border-b py-4 text-center font-semibold text-16 text-white">
              {title}
            </h5>
            <div className="pt-4 pb-2.5">{content}</div>
          </HoverCardContent>
        )}
      </HoverCard>
      {!isDesktop && (
        <Dialog onOpenChange={setIsOpen} open={isOpen}>
          <DialogContent
            className={cn(
              "rounded-t-[20px] bg-rich-black shadow-0-0-4 shadow-deep-koamaru",
              className
            )}
            overlayClassName="bg-gray-cool/64"
          >
            <DialogHeader className="border-white/10 border-b py-5">
              <DialogTitle className="flex items-center justify-center text-center font-semibold text-16 text-white">
                {title}
              </DialogTitle>
            </DialogHeader>
            <div className="p-5">{content}</div>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
